import { atom, useAtom } from "jotai";

const refContainer = atom(null);

const useUnitPage = () => {
  return useAtom(refContainer);
};

export default useUnitPage;
